var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('h3',[_c('a',{attrs:{"href":_vm.repo.html_url,"target":"_blanc"}},[_vm._v(_vm._s(_vm.repo.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }